import { render, staticRenderFns } from "./CompilationRootPage.vue?vue&type=template&id=2a3e6072&scoped=true&"
import script from "./CompilationRootPage.vue?vue&type=script&lang=ts&"
export * from "./CompilationRootPage.vue?vue&type=script&lang=ts&"
import style0 from "./CompilationRootPage.vue?vue&type=style&index=0&id=2a3e6072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3e6072",
  null
  
)

export default component.exports